module.exports = __webpack_public_path__ + "static/media/texture-season-9.9388d769.jpg";